
import { PropType, defineComponent } from 'vue';

export default defineComponent({
    emits: ['update:modelValue'],
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        modelValue: {
            type: Number,
        },
        name: {
            type: String,
            default: '',
        },
        radioValue: {
            type: [Number, undefined] as PropType<number | undefined>,
        },
    },
});
